import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface SearchIconProps {
  size?: number;
  color?: string;
}

const SearchIcon: React.FC<SearchIconProps> = ({ size = 24, color = '#80838D' }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.4248 3.4751C11.0587 3.4751 12.4355 4.04742 13.583 5.20264C14.7312 6.35864 15.2998 7.74054 15.2998 9.37549C15.2998 9.95398 15.2179 10.513 15.0537 11.0542L14.9785 11.2847C14.7649 11.895 14.4432 12.4714 14.0098 13.0132L13.7285 13.3638L14.0479 13.6802L20.123 19.7056L20.1328 19.7144L20.168 19.7495C20.1897 19.7767 20.2002 19.8088 20.2002 19.8628C20.2002 19.9206 20.1829 19.9856 20.0967 20.0718C20.0428 20.1257 19.9874 20.1498 19.9004 20.1499C19.8352 20.1499 19.7874 20.1364 19.7451 20.1069L19.7031 20.0718L13.6787 14.0464L13.3496 13.7173L12.9971 14.022C12.603 14.3635 12.149 14.6419 11.6309 14.855L11.4043 14.9429C10.7955 15.1635 10.1452 15.2749 9.4502 15.2749C7.78009 15.2749 6.38285 14.7007 5.22852 13.5464C4.07238 12.3902 3.50009 11.0092 3.5 9.37549C3.5 7.74152 4.07222 6.35991 5.22852 5.20361C6.38378 4.04835 7.77285 3.47514 9.4248 3.4751ZM9.4248 3.9751C7.92687 3.97514 6.63692 4.50614 5.58398 5.55908C4.5323 6.61077 4 7.8923 4 9.37549C4.00009 10.8585 4.53245 12.1393 5.58398 13.1909C6.63692 14.2439 7.92686 14.7749 9.4248 14.7749C10.9081 14.7749 12.1865 14.243 13.2305 13.1899C14.2732 12.138 14.7997 10.8571 14.7998 9.37549C14.7998 7.89389 14.2731 6.61298 13.2305 5.56104C12.1865 4.50794 10.9081 3.9751 9.4248 3.9751Z"
        fill={color}
        stroke="#1C2024"
      />
    </Svg>
  );
};

export default SearchIcon;